import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/esnext.typed-array.to-reversed.js";
import "core-js/modules/esnext.typed-array.to-sorted.js";
import "core-js/modules/esnext.typed-array.with.js";
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import Vue, { ref, onMounted, computed, watch, h } from 'vue';
import { useOutboundInvoices } from '@/use/invoices/outbound';
import { useWorkOrders } from '@/use/work-orders';
import { DRAWER_CLOSED, DRAWER_OPENED, ERROR, PDF_DOWNLOAD } from '@/constants/icons';
import { useToasts } from '@/use/toasts';
import { validate } from '@/utils';
import { snakeCase, cloneDeep } from 'lodash';
import { useBackgroundTasks } from '@/use/background-tasks';
import { BackgroundTaskSources, BackgroundTaskFormats, ModalWidthSize } from '@/types/enums';
import { useSession } from '@/use/session';
import { useTrips } from '@/use/trips';
export default /*#__PURE__*/_defineComponent({
  __name: 'uc-workorder-details-modal',
  props: {
    workOrderId: {
      type: [Number, String],
      default: null
    },
    tripIds: {
      type: Array,
      default: null
    },
    workOrderIds: {
      type: Array,
      default: () => []
    },
    clientId: {
      type: Number,
      default: null
    },
    bulkWorkOrderReport: {
      type: Boolean,
      default: false
    },
    clientIds: {
      type: Array,
      default: null
    },
    visible: {
      type: Boolean,
      default: false
    },
    resources: {
      type: Array,
      default: null
    },
    bulkTripReport: {
      type: Boolean,
      default: false
    },
    bulkTripReportFromWO: {
      type: Boolean,
      default: false
    },
    emitChange: {
      type: Boolean,
      default: false
    },
    tripReportParams: {
      type: Object,
      default: () => {}
    }
  },
  emits: ['file-created', 'show-uploader', 'wo-report-file-uploaded', 'close', 'trip-report-params-value-updated'],
  setup(__props, {
    expose,
    emit
  }) {
    var _localTripReportParam;
    const props = __props;
    const {
      INVOICE_GROUP_BY_CONFIG_OPTIONS
    } = useOutboundInvoices();
    const exportFormatRadiosBtn = ref([{
      label: 'PDF',
      value: 'pdf'
    }]);
    const photoVersion = ref('small');
    const {
      session
    } = useSession();
    const {
      getWoTripReportsById
    } = useWorkOrders();
    const {
      generateTripReports,
      getTripReportTemplates,
      postTripReportTemplate,
      renderBulkGenerateTripReport,
      bulkGenerateTripReportData
    } = useTrips();
    const {
      addToast
    } = useToasts();
    const attachmentWorkOrderDetailModal = ref(props.visible);
    const {
      emptyFileName,
      moreThanOnePeriod,
      containsInvalidCharacter
    } = validate;
    const woHeaders = ref([]);
    const selectedReportTemplate = ref({
      id: null,
      name: '',
      reportType: '',
      headers: [],
      templateType: null,
      companyId: null,
      userId: null
    });
    const userSpecific = ref(false);
    const loading = ref(false);
    const templateName = ref('');
    const keyIndex = ref(0);
    const surveyIds = ref([]);
    const localTripReportParams = ref(cloneDeep(props.tripReportParams));
    const generateReportBy = ref((_localTripReportParam = localTripReportParams.value) !== null && _localTripReportParam !== void 0 && _localTripReportParam.exportType ? INVOICE_GROUP_BY_CONFIG_OPTIONS.filter(filterType => {
      var _localTripReportParam2;
      return filterType.name === ((_localTripReportParam2 = localTripReportParams.value) === null || _localTripReportParam2 === void 0 ? void 0 : _localTripReportParam2.exportType);
    })[0] : INVOICE_GROUP_BY_CONFIG_OPTIONS.filter(filterType => {
      return filterType.name === 'Work Order';
    })[0]);
    const reportFormat = ref('pdf');
    const showAttachmentWorkOrderDetailModal = () => {
      attachmentWorkOrderDetailModal.value = true;
    };
    const closeModal = () => {
      attachmentWorkOrderDetailModal.value = false;
      renderBulkGenerateTripReport.value = false;
      bulkGenerateTripReportData.value = [];
      emit('close');
    };
    watch(() => props.visible, () => {
      if (props.visible) {
        showAttachmentWorkOrderDetailModal();
      } else {
        closeModal();
      }
    });
    const confirmBackgroundTask = async () => {
      var _generateReportBy$val;
      setSurveyIds();
      loading.value = true;
      const {
        bulkTripReport,
        workOrderId,
        resources
      } = props;
      const {
        createBackgroundTask
      } = useBackgroundTasks();
      // We get selected resource as a row data in bulk, so we need to pass this to avoid and fetch workOrderId from row data
      let selectedWorkOrderId;
      if (props.bulkTripReportFromWO) {
        selectedWorkOrderId = props.resources[0].id;
      } else if (bulkTripReport) {
        selectedWorkOrderId = workOrderId;
      } else {
        selectedWorkOrderId = resources[0].workOrderId;
      }
      const tripIds = props.bulkTripReportFromWO ? [] : resources.map(resource => resource.id);
      // Create form data
      const formData = new FormData();
      const formDataEntries = {
        'background_task[job_type]': 'bulk_work_order_download_trip_report',
        'background_task[source]': BackgroundTaskSources.IDS,
        'background_task[content_types]': JSON.stringify(checkedLabels.value),
        'background_task[report_format]': reportFormat.value,
        'background_task[export_type]': ((_generateReportBy$val = generateReportBy.value) === null || _generateReportBy$val === void 0 ? void 0 : _generateReportBy$val.name) || '',
        'background_task[work_order_id]': selectedWorkOrderId,
        'background_task[trip_ids]': JSON.stringify(tripIds),
        'background_task[work_order_trip_report]': 'true',
        'background_task[format]': BackgroundTaskFormats.PDF,
        'background_task[survey_ids]': JSON.stringify(surveyIds.value)
      };
      // Append entries to FormData
      for (const [key, value] of Object.entries(formDataEntries)) {
        formData.append(key, value);
      }
      // Execute background task and handle UI
      await createBackgroundTask(formData);
      loading.value = false;
      let toast = {};
      toast = {
        timeout: 7000,
        color: 'primary',
        prependIcon: PDF_DOWNLOAD,
        message: '',
        component: () => h('div', {}, [bulkTripReport && resources.length > 1 || props.bulkTripReportFromWO ? 'Your report for Trips of WO ' : `Your report for Trip# ${resources[0].position} of WO `, h('router-link', {
          props: {
            to: `/work-orders/${selectedWorkOrderId}`
          },
          style: {
            color: 'white'
          }
        }, [`#${selectedWorkOrderId}`]), ' is being processed'])
      };
      addToast(toast);
      closeModal();
    };
    const generateReportOrConfirmBackgroundTask = () => {
      if (!hideAttachmentUI.value) {
        confirmBackgroundTask();
      } else {
        generateWoReport();
      }
    };
    const generateWoReport = async (autoGenearte = false) => {
      if (autoGenearte) {
        checkedLabels.value = localTripReportParams.value.contentTypes;
        reportFormat.value = String(localTripReportParams.value.reportFormat);
        generateReportBy.value.name = String(localTripReportParams.value.exportType);
      }
      try {
        if (props.workOrderId !== null) {
          var _generateReportBy$val2, _props$tripIds;
          emit('show-uploader', true);
          const res = await generateTripReports({
            contentTypes: checkedLabels.value,
            reportFormat: reportFormat.value,
            exportType: (_generateReportBy$val2 = generateReportBy.value) === null || _generateReportBy$val2 === void 0 ? void 0 : _generateReportBy$val2.name,
            workOrderId: props.workOrderId,
            tripIds: (_props$tripIds = props.tripIds) === null || _props$tripIds === void 0 ? void 0 : _props$tripIds.toString(),
            workOrderIds: props.workOrderIds
          });
          const fileName = props.workOrderIds === null ? `Wo#${props.workOrderId} Report.pdf` : `${props.workOrderIds.length} WO Reports.pdf`;
          emit('wo-report-file-uploaded', true);
          if (res.data !== undefined && res.data !== false) {
            const atobConverted = window.atob(res.data);
            const atobConvertedArr = new Array(atobConverted.length);
            for (let i = 0; i < atobConverted.length; i++) {
              atobConvertedArr[i] = atobConverted.charCodeAt(i);
            }
            const atobConvertedUintArr = new Uint8Array(atobConvertedArr);
            const blobFile = new Blob([atobConvertedUintArr], {
              type: 'application/pdf'
            });
            const newFile = new File([blobFile], fileName, {
              type: 'application/pdf'
            });
            emit('file-created', newFile);
            emit('show-uploader', false);
          } else {
            emit('show-uploader', false);
            emit('wo-report-file-uploaded', false);
          }
        }
      } catch (err) {
        console.error(err);
      }
      return null;
    };
    const handleTripReport = () => {
      getSelectedWoReportLabels();
      props.bulkWorkOrderReport ? processTripReportParameters() : generateReportOrConfirmBackgroundTask();
      closeModal();
    };
    const processTripReportParameters = () => {
      var _generateReportBy$val3, _props$tripIds2;
      localTripReportParams.value = {
        contentTypes: checkedLabels.value,
        reportFormat: reportFormat.value,
        exportType: (_generateReportBy$val3 = generateReportBy.value) === null || _generateReportBy$val3 === void 0 ? void 0 : _generateReportBy$val3.name,
        workOrderId: String(props.workOrderId),
        tripIds: (_props$tripIds2 = props.tripIds) === null || _props$tripIds2 === void 0 ? void 0 : _props$tripIds2.toString(),
        workOrderIds: props.workOrderIds.map(id => String(id)),
        tripReportTypes: woHeaders.value
      };
      if (props.emitChange) emit('trip-report-params-value-updated', localTripReportParams.value);
    };
    const photosArr = ref([]);
    const photosData = ref({});
    const photosBtnGroup = () => {
      Object.keys(photosData.value).forEach(key => {
        if (!photosArr.value.map(val => val.value).includes(key)) {
          photosArr.value.push({
            label: photosData.value[key].label,
            value: key
          });
        }
      });
    };
    const checkedLabels = ref([]);
    const getSelectedWoReportLabels = () => {
      const selectedLabels = [];
      Object.keys(woHeaders.value.data).forEach(key => {
        if (key !== 'multiselectable') {
          if (woHeaders.value.data[key].selected) {
            if (key === 'equipment' && !selectedLabels.includes(snakeCase(key))) {
              selectedLabels.push(snakeCase(key));
            }
            if (!selectedLabels.includes(snakeCase(woHeaders.value.data[key].label))) {
              selectedLabels.push(snakeCase(woHeaders.value.data[key].label));
            }
          }
          if (woHeaders.value.data[key].types !== undefined) {
            Object.keys(woHeaders.value.data[key].types).forEach(reportkey => {
              var _woHeaders$value$data;
              if ((_woHeaders$value$data = woHeaders.value.data[key].types[reportkey]) !== null && _woHeaders$value$data !== void 0 && _woHeaders$value$data.selected) {
                if (!selectedLabels.includes(snakeCase(reportkey))) {
                  selectedLabels.push(snakeCase(reportkey));
                }
              }
              if (reportkey === 'photos') {
                Object.values(woHeaders.value.data[key].types[reportkey].types).forEach(photoObj => {
                  if (!selectedLabels.includes(snakeCase(photoObj.label)) && photoObj.selected) {
                    selectedLabels.push(snakeCase(photoObj.label));
                  }
                });
              }
            });
          }
          if (key === 'inspectionSubItems') {
            Object.keys(woHeaders.value.data.inspectionSubItems).forEach(inspectionObj => {
              if (woHeaders.value.data.inspectionSubItems[inspectionObj].selected) {
                if (!selectedLabels.includes(snakeCase(woHeaders.value.data.inspectionSubItems[inspectionObj].label))) {
                  selectedLabels.push(snakeCase(woHeaders.value.data.inspectionSubItems[inspectionObj].label));
                }
              }
            });
          }
          if (key === 'deficiencySubItems') {
            Object.keys(woHeaders.value.data.deficiencySubItems).forEach(deficiencyObj => {
              if (woHeaders.value.data.deficiencySubItems[deficiencyObj].selected) {
                if (!selectedLabels.includes(snakeCase(woHeaders.value.data.deficiencySubItems[deficiencyObj].label))) {
                  selectedLabels.push(snakeCase(woHeaders.value.data.deficiencySubItems[deficiencyObj].label));
                }
              }
            });
          }
        }
      });
      Object.values(woHeaders.value.surveyAndSurveyTemplateData).forEach(customForm => {
        if (customForm.selected) selectedLabels.push(customForm.formattedTemplateName);
      });
      checkedLabels.value = selectedLabels;
    };
    const addOpenProperty = obj => {
      delete obj.multiselectable;
      Object.values(obj).forEach(value => {
        if (Object.prototype.hasOwnProperty.call(value, 'types')) {
          Vue.set(value, 'open', true);
          Object.values(value.types).forEach(subValue => {
            Vue.set(subValue, 'open', true);
          });
        } else if (value.label === 'Forms and Reports') {
          Vue.set(value, 'open', true);
        }
      });
      return obj;
    };
    onMounted(async () => {
      init();
    });
    const init = async () => {
      var _localTripReportParam3;
      loading.value = true;
      const tripReportTypes = (_localTripReportParam3 = localTripReportParams.value) === null || _localTripReportParam3 === void 0 ? void 0 : _localTripReportParam3.tripReportTypes;
      if (tripReportTypes) {
        woHeaders.value = tripReportTypes;
      } else {
        const params = {
          workOrderId: props.workOrderId,
          workOrderIds: props.workOrderIds
        };
        if (props.bulkTripReportFromWO) {
          params.workOrderId = props.resources[0].id;
        } else if (props.bulkTripReport) {
          params.workOrderId = props.workOrderId;
          params.tripIds = props.resources.map(resource => Number(resource.id));
        } else if (!hideAttachmentUI.value) {
          params.workOrderId = props.resources[0].workOrderId;
          params.tripIds = [props.resources[0].id];
        }
        woHeaders.value = await getWoTripReportsById({
          ...params
        });
      }
      woHeaders.value = {
        ...woHeaders.value,
        data: addOpenProperty(woHeaders.value.data),
        surveyAndSurveyTemplateData: woHeaders.value.surveyAndSurveyTemplateData
      };
      photosData.value = woHeaders.value.data.trip.types.photos.types;
      photosBtnGroup();
      loading.value = false;
    };
    const selectTripSubTypes = () => {
      var _woHeaders$value, _woHeaders$value$data2, _woHeaders$value$data3;
      if ((_woHeaders$value = woHeaders.value) !== null && _woHeaders$value !== void 0 && (_woHeaders$value$data2 = _woHeaders$value.data) !== null && _woHeaders$value$data2 !== void 0 && (_woHeaders$value$data3 = _woHeaders$value$data2.trip) !== null && _woHeaders$value$data3 !== void 0 && _woHeaders$value$data3.types) {
        var _woHeaders$value2, _woHeaders$value2$dat, _woHeaders$value2$dat2;
        Object.values((_woHeaders$value2 = woHeaders.value) === null || _woHeaders$value2 === void 0 ? void 0 : (_woHeaders$value2$dat = _woHeaders$value2.data) === null || _woHeaders$value2$dat === void 0 ? void 0 : (_woHeaders$value2$dat2 = _woHeaders$value2$dat.trip) === null || _woHeaders$value2$dat2 === void 0 ? void 0 : _woHeaders$value2$dat2.types).forEach(subTypevalue => {
          var _woHeaders$value3, _woHeaders$value3$dat, _woHeaders$value3$dat2;
          subTypevalue.selected = (_woHeaders$value3 = woHeaders.value) === null || _woHeaders$value3 === void 0 ? void 0 : (_woHeaders$value3$dat = _woHeaders$value3.data) === null || _woHeaders$value3$dat === void 0 ? void 0 : (_woHeaders$value3$dat2 = _woHeaders$value3$dat.trip) === null || _woHeaders$value3$dat2 === void 0 ? void 0 : _woHeaders$value3$dat2.selected;
        });
      }
    };
    const photoVersionChanged = event => {
      const photoTypes = woHeaders.value.data.trip.types.photos.types;
      Object.keys(photoTypes).forEach(key => {
        photoTypes[key].selected = key === event;
      });
    };
    const selectReportSubTypes = () => {
      var _woHeaders$value4, _woHeaders$value4$dat, _woHeaders$value5, _woHeaders$value5$dat;
      Object.values([(_woHeaders$value4 = woHeaders.value) === null || _woHeaders$value4 === void 0 ? void 0 : (_woHeaders$value4$dat = _woHeaders$value4.data) === null || _woHeaders$value4$dat === void 0 ? void 0 : _woHeaders$value4$dat.otherEquipmentReport, (_woHeaders$value5 = woHeaders.value) === null || _woHeaders$value5 === void 0 ? void 0 : (_woHeaders$value5$dat = _woHeaders$value5.data) === null || _woHeaders$value5$dat === void 0 ? void 0 : _woHeaders$value5$dat.equipment]).forEach(subTypevalue => {
        var _woHeaders$value6, _woHeaders$value6$dat, _woHeaders$value6$dat2;
        subTypevalue.selected = (_woHeaders$value6 = woHeaders.value) === null || _woHeaders$value6 === void 0 ? void 0 : (_woHeaders$value6$dat = _woHeaders$value6.data) === null || _woHeaders$value6$dat === void 0 ? void 0 : (_woHeaders$value6$dat2 = _woHeaders$value6$dat.report) === null || _woHeaders$value6$dat2 === void 0 ? void 0 : _woHeaders$value6$dat2.selected;
      });
      selectEquipmentSubTypes();
      selectOtherEquipmentSubTypes();
    };
    const selectEquipmentSubTypes = () => {
      var _woHeaders$value7, _woHeaders$value7$dat, _woHeaders$value7$dat2;
      if ((_woHeaders$value7 = woHeaders.value) !== null && _woHeaders$value7 !== void 0 && (_woHeaders$value7$dat = _woHeaders$value7.data) !== null && _woHeaders$value7$dat !== void 0 && (_woHeaders$value7$dat2 = _woHeaders$value7$dat.equipment) !== null && _woHeaders$value7$dat2 !== void 0 && _woHeaders$value7$dat2.types) {
        var _woHeaders$value8, _woHeaders$value8$dat, _woHeaders$value8$dat2;
        Object.values((_woHeaders$value8 = woHeaders.value) === null || _woHeaders$value8 === void 0 ? void 0 : (_woHeaders$value8$dat = _woHeaders$value8.data) === null || _woHeaders$value8$dat === void 0 ? void 0 : (_woHeaders$value8$dat2 = _woHeaders$value8$dat.equipment) === null || _woHeaders$value8$dat2 === void 0 ? void 0 : _woHeaders$value8$dat2.types).forEach(subTypevalue => {
          var _woHeaders$value9, _woHeaders$value9$dat, _woHeaders$value9$dat2;
          subTypevalue.selected = (_woHeaders$value9 = woHeaders.value) === null || _woHeaders$value9 === void 0 ? void 0 : (_woHeaders$value9$dat = _woHeaders$value9.data) === null || _woHeaders$value9$dat === void 0 ? void 0 : (_woHeaders$value9$dat2 = _woHeaders$value9$dat.equipment) === null || _woHeaders$value9$dat2 === void 0 ? void 0 : _woHeaders$value9$dat2.selected;
          if (subTypevalue.label === 'Inspection') {
            var _woHeaders$value0, _woHeaders$value0$dat;
            Object.values((_woHeaders$value0 = woHeaders.value) === null || _woHeaders$value0 === void 0 ? void 0 : (_woHeaders$value0$dat = _woHeaders$value0.data) === null || _woHeaders$value0$dat === void 0 ? void 0 : _woHeaders$value0$dat.inspectionSubItems).forEach(inspectionSubItem => {
              var _woHeaders$value1, _woHeaders$value1$dat, _woHeaders$value1$dat2;
              inspectionSubItem.selected = (_woHeaders$value1 = woHeaders.value) === null || _woHeaders$value1 === void 0 ? void 0 : (_woHeaders$value1$dat = _woHeaders$value1.data) === null || _woHeaders$value1$dat === void 0 ? void 0 : (_woHeaders$value1$dat2 = _woHeaders$value1$dat.equipment) === null || _woHeaders$value1$dat2 === void 0 ? void 0 : _woHeaders$value1$dat2.selected;
            });
          }
          if (subTypevalue.label === 'Deficiency') {
            var _woHeaders$value10, _woHeaders$value10$da;
            const items = Object.values(((_woHeaders$value10 = woHeaders.value) === null || _woHeaders$value10 === void 0 ? void 0 : (_woHeaders$value10$da = _woHeaders$value10.data) === null || _woHeaders$value10$da === void 0 ? void 0 : _woHeaders$value10$da.deficiencySubItems) ?? {});
            items.forEach(deficiencySubItem => {
              var _woHeaders$value11, _woHeaders$value11$da, _woHeaders$value11$da2;
              deficiencySubItem.selected = (_woHeaders$value11 = woHeaders.value) === null || _woHeaders$value11 === void 0 ? void 0 : (_woHeaders$value11$da = _woHeaders$value11.data) === null || _woHeaders$value11$da === void 0 ? void 0 : (_woHeaders$value11$da2 = _woHeaders$value11$da.equipment) === null || _woHeaders$value11$da2 === void 0 ? void 0 : _woHeaders$value11$da2.selected;
            });
          }
        });
      }
    };
    const selectOtherEquipmentSubTypes = () => {
      var _woHeaders$value12, _woHeaders$value12$da, _woHeaders$value12$da2;
      if ((_woHeaders$value12 = woHeaders.value) !== null && _woHeaders$value12 !== void 0 && (_woHeaders$value12$da = _woHeaders$value12.data) !== null && _woHeaders$value12$da !== void 0 && (_woHeaders$value12$da2 = _woHeaders$value12$da.otherEquipmentReport) !== null && _woHeaders$value12$da2 !== void 0 && _woHeaders$value12$da2.types) {
        var _woHeaders$value13, _woHeaders$value13$da, _woHeaders$value13$da2;
        Object.values((_woHeaders$value13 = woHeaders.value) === null || _woHeaders$value13 === void 0 ? void 0 : (_woHeaders$value13$da = _woHeaders$value13.data) === null || _woHeaders$value13$da === void 0 ? void 0 : (_woHeaders$value13$da2 = _woHeaders$value13$da.otherEquipmentReport) === null || _woHeaders$value13$da2 === void 0 ? void 0 : _woHeaders$value13$da2.types).forEach(subTypevalue => {
          var _woHeaders$value14, _woHeaders$value14$da, _woHeaders$value14$da2;
          subTypevalue.selected = (_woHeaders$value14 = woHeaders.value) === null || _woHeaders$value14 === void 0 ? void 0 : (_woHeaders$value14$da = _woHeaders$value14.data) === null || _woHeaders$value14$da === void 0 ? void 0 : (_woHeaders$value14$da2 = _woHeaders$value14$da.otherEquipmentReport) === null || _woHeaders$value14$da2 === void 0 ? void 0 : _woHeaders$value14$da2.selected;
        });
        Object.values(woHeaders.value.surveyAndSurveyTemplateData).forEach(customForm => {
          var _woHeaders$value15, _woHeaders$value15$da, _woHeaders$value15$da2;
          customForm.selected = (_woHeaders$value15 = woHeaders.value) === null || _woHeaders$value15 === void 0 ? void 0 : (_woHeaders$value15$da = _woHeaders$value15.data) === null || _woHeaders$value15$da === void 0 ? void 0 : (_woHeaders$value15$da2 = _woHeaders$value15$da.otherEquipmentReport) === null || _woHeaders$value15$da2 === void 0 ? void 0 : _woHeaders$value15$da2.selected;
        });
      }
    };
    const selectInspectionSubTypes = selected => {
      var _woHeaders$value16, _woHeaders$value16$da;
      Object.values((_woHeaders$value16 = woHeaders.value) === null || _woHeaders$value16 === void 0 ? void 0 : (_woHeaders$value16$da = _woHeaders$value16.data) === null || _woHeaders$value16$da === void 0 ? void 0 : _woHeaders$value16$da.inspectionSubItems).forEach(inspectionSubItem => {
        inspectionSubItem.selected = selected;
      });
    };
    const selectDeficiencySubTypes = selected => {
      var _woHeaders$value17, _woHeaders$value17$da;
      const items = Object.values(((_woHeaders$value17 = woHeaders.value) === null || _woHeaders$value17 === void 0 ? void 0 : (_woHeaders$value17$da = _woHeaders$value17.data) === null || _woHeaders$value17$da === void 0 ? void 0 : _woHeaders$value17$da.deficiencySubItems) ?? {});
      items.forEach(deficiencySubItem => {
        deficiencySubItem.selected = selected;
      });
    };
    const hideAttachmentUI = computed(() => {
      return !(props.resources && props.resources[0]);
    });
    /**
     On template selection, We are overwriting the current work order headers and reports parameters for include report details.
     For Example: work order headers data as following format
     {
        "trip": {
            "label": "Trip",
            "selected": true,
            "types": {...},
            "open": true
        },
        "report": {
            "label": "Forms and Reports",
            "selected": false,
            "open": true
        },
        "equipment": {
            "label": "Equipment Report",
            "selected": false,
            "types": {...},
            "open": true
        },
        "deficiencyColorTags": {},
        "otherEquipmentReport": {
            "label": "Other Reports",
            "selected": false,
            "types": {...},
            "open": true
        }
      }
    */
    const updateSelectedTemplateWoHeaders = () => {
      Object.keys(woHeaders.value.data).forEach(key => {
        // skip the Deficiency Color Tags values
        if (key === 'inspectionSubItems' || key === 'deficiencySubItems') {
          return;
        }
        if (selectedReportTemplate.value.headers.includes(snakeCase(woHeaders.value.data[key].label))) {
          woHeaders.value.data[key].selected = true;
        } else {
          woHeaders.value.data[key].selected = false;
        }
        if (woHeaders.value.data[key].types !== undefined) {
          Object.keys(woHeaders.value.data[key].types).forEach(reportkey => {
            if (selectedReportTemplate.value.headers.includes(snakeCase(reportkey))) {
              woHeaders.value.data[key].types[reportkey].selected = true;
            } else {
              woHeaders.value.data[key].types[reportkey].selected = false;
            }
            if (reportkey === 'photos') {
              Object.keys(woHeaders.value.data[key].types[reportkey].types).forEach(photoObj => {
                if (selectedReportTemplate.value.headers.includes(snakeCase(photoObj))) {
                  woHeaders.value.data[key].types[reportkey].types[photoObj].selected = true;
                } else {
                  woHeaders.value.data[key].types[reportkey].types[photoObj].selected = false;
                }
              });
            }
            if (reportkey === 'inspection') {
              Object.keys(woHeaders.value.data.inspectionSubItems).forEach(inspectionObj => {
                if (selectedReportTemplate.value.headers.includes(snakeCase(inspectionObj))) {
                  woHeaders.value.data.inspectionSubItems[inspectionObj].selected = true;
                } else {
                  woHeaders.value.data.inspectionSubItems[inspectionObj].selected = false;
                }
              });
            }
            if (reportkey === 'equipmentCaptureDeficiency') {
              Object.keys(woHeaders.value.data.deficiencySubItems).forEach(deficiencyObj => {
                if (selectedReportTemplate.value.headers.includes(snakeCase(deficiencyObj))) {
                  woHeaders.value.data.deficiencySubItems[deficiencyObj].selected = true;
                } else {
                  woHeaders.value.data.deficiencySubItems[deficiencyObj].selected = false;
                }
              });
            }
          });
        }
      });
      Object.values(woHeaders.value.surveyAndSurveyTemplateData).forEach(customForm => {
        if (selectedReportTemplate.value.headers.includes(customForm.formattedTemplateName)) {
          customForm.selected = true;
        }
      });
    };
    const saveTemplate = async () => {
      loading.value = true;
      getSelectedWoReportLabels();
      const res = await postTripReportTemplate({
        reportType: 'custom',
        name: templateName.value,
        headers: checkedLabels.value,
        userId: userSpecific.value ? session.loggedUser.id : null
      });
      if (res.data) {
        keyIndex.value += 1; // Need to re-render the uc-select when the new template is added.
        const toast = {
          timeout: 7000,
          color: 'primary',
          message: 'Template saved successfully.'
        };
        templateName.value = '';
        userSpecific.value = false;
        addToast(toast);
      } else {
        const toast = {
          timeout: 7000,
          color: 'error',
          prependIcon: ERROR,
          message: 'Failed to create template. Please try again.'
        };
        addToast(toast);
      }
      loading.value = false;
    };
    // Template name validation empty, invalid characters, we if any each function returns error message with why failed valid and save button gets disable
    const disableSaveTemplate = computed(() => {
      return typeof emptyFileName(templateName.value) === 'string' || typeof moreThanOnePeriod(templateName.value) === 'string' || typeof containsInvalidCharacter(templateName.value) === 'string';
    });
    const headerText = () => {
      if (props.bulkTripReport) {
        return `Generate Report for Trips of WO# ${props.bulkTripReportFromWO ? props.resources[0].id : props.workOrderId}`;
      } else if (!hideAttachmentUI.value) {
        return `Generate Report for Trip# ${props.resources[0].position} of WO# ${props.resources[0].workOrderId}`;
      } else {
        return 'Attach Work Order Details';
      }
    };
    const setSurveyIds = () => {
      if (woHeaders.value.surveyAndSurveyTemplateData) {
        woHeaders.value.surveyAndSurveyTemplateData.forEach(data => {
          if (data.selected) surveyIds.value.push(data.surveyId);
        });
      }
    };
    watch(() => props.tripReportParams, newVal => {
      localTripReportParams.value = newVal;
    });
    expose({
      showAttachmentWorkOrderDetailModal,
      generateWoReport,
      init
    });
    return {
      __sfc: true,
      props,
      INVOICE_GROUP_BY_CONFIG_OPTIONS,
      exportFormatRadiosBtn,
      photoVersion,
      session,
      getWoTripReportsById,
      generateTripReports,
      getTripReportTemplates,
      postTripReportTemplate,
      renderBulkGenerateTripReport,
      bulkGenerateTripReportData,
      addToast,
      attachmentWorkOrderDetailModal,
      emptyFileName,
      moreThanOnePeriod,
      containsInvalidCharacter,
      emit,
      woHeaders,
      selectedReportTemplate,
      userSpecific,
      loading,
      templateName,
      keyIndex,
      surveyIds,
      localTripReportParams,
      generateReportBy,
      reportFormat,
      showAttachmentWorkOrderDetailModal,
      closeModal,
      confirmBackgroundTask,
      generateReportOrConfirmBackgroundTask,
      generateWoReport,
      handleTripReport,
      processTripReportParameters,
      photosArr,
      photosData,
      photosBtnGroup,
      checkedLabels,
      getSelectedWoReportLabels,
      addOpenProperty,
      init,
      selectTripSubTypes,
      photoVersionChanged,
      selectReportSubTypes,
      selectEquipmentSubTypes,
      selectOtherEquipmentSubTypes,
      selectInspectionSubTypes,
      selectDeficiencySubTypes,
      hideAttachmentUI,
      updateSelectedTemplateWoHeaders,
      saveTemplate,
      disableSaveTemplate,
      headerText,
      setSurveyIds,
      DRAWER_CLOSED,
      DRAWER_OPENED,
      ModalWidthSize
    };
  }
});